import { useThemeContext } from '@oberoninternal/travelbase-ds/hooks/useThemeContext';
import { useRouter } from 'next/router';
import { useState, useCallback, useEffect } from 'react';

export interface MapSize {
    top: number;
    height: number | string;
}

const useMapSize = () => {
    const [size, setSize] = useState<null | MapSize>(null);
    const { mediaQueriesValues } = useThemeContext();
    const router = useRouter();
    const isEmbedPage = router.pathname.includes('embed');

    const calculateSize = useCallback(() => {
        const appContainer = document.querySelector<HTMLElement>('#__next');
        if (appContainer) {
            const mobileView = window.innerWidth < mediaQueriesValues.m;
            setSize({
                top: mobileView ? 0 : appContainer.offsetTop,
                height: mobileView ? '100vh' : isEmbedPage ? 600 : window.innerHeight - appContainer.offsetTop,
            });
        }
    }, [isEmbedPage, mediaQueriesValues.m]);

    useEffect(() => {
        calculateSize();
        window.addEventListener('resize', calculateSize);
        return () => window.removeEventListener('resize', calculateSize);
    }, [calculateSize]);

    return size;
};

export default useMapSize;
